import { render, staticRenderFns } from "./MessageCardCard.vue?vue&type=template&id=520436d4&lang=pug&"
import script from "./MessageCardCard.vue?vue&type=script&lang=ts&"
export * from "./MessageCardCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports